import { toRelayGlobalId } from '../../../../../utils/relay';
import type { RuntimeBindingInputArgs } from './types';

const SOUND_MEASURING_POINT_RELAY_TYPE = 'SoundMeasuringPoint';

/**
 * The sound queries take a relay global id where the vibration ones take an integer, so a sound
 * service has to encode its measuring point id before passing it as a query variable.
 */
export function toSoundMeasuringPointRelayId(measuringPointId: string): string {
    return toRelayGlobalId(SOUND_MEASURING_POINT_RELAY_TYPE, measuringPointId);
}

export type MeasuringPointWindowInput = {
    measuringPointId: string;
    startTime: number;
    endTime: number;
};

/**
 * The measuring point and graph window every per-measuring-point service needs as its input.
 * `label` names the service in both error messages.
 */
export function buildRequiredMeasuringPointWindowInput(
    { context, graphTimeWindow }: Pick<RuntimeBindingInputArgs, 'context' | 'graphTimeWindow'>,
    label: string
): MeasuringPointWindowInput {
    if (!context || context.kind !== 'measuring-point') {
        throw new Error(`${label} require measuring-point context.`);
    }

    if (!graphTimeWindow) {
        throw new Error(`Graph runtime settings are required to resolve ${label}.`);
    }

    return {
        measuringPointId: context.measuringPoint.id,
        startTime: graphTimeWindow.viewStartTs,
        endTime: graphTimeWindow.viewEndTs,
    };
}
